import { LoyaltyMemberTierLevel } from '../../../models/api/tracker-details.interfaces';

export const MillionMilerMocks: LoyaltyMemberTierLevel = {
  tierStatusDesc: 'CURRENT',
  tierLevelClassificatinCode: 'MM',
  tierLevelCode: '07',
  tierLevelCodeDesc: '7 Million Miler',
  tierLevelStartLocalDate: '2020-04-25',
  tierLevelEndLocalDate: '2079-12-31',
  tierComp: false,
  tierMethodOfAttainmentCode: 'TEST'
};
